import { render, staticRenderFns } from "./CrewMembersSection.vue?vue&type=template&id=5fa15467&scoped=true"
import script from "./CrewMembersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CrewMembersSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CrewMembersSection.vue?vue&type=style&index=0&id=5fa15467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa15467",
  null
  
)

export default component.exports